export const id = "skip-nav";

export default function SkipNavContent() {
  return <div id={id} />;
}
